module.exports = __webpack_public_path__ + "img/amaxz.cc0cf0d0.jpg";